<template>
    <div>
        <el-dialog  :center="true" :close-on-click-modal="false" title="审批意见" :visible.sync="rejectDialogShow"  @close="rejectDialogShowClr" width="75%">
            <div>驳回原因:
                <div style="position: absolute; color: #F56C6C; width: 1px; height: 1px;z-index: 111111; margin-left: -10px;margin-top: -16px;">*</div>
            </div>


            <el-checkbox-group v-model="checkedCitiesList" @change="handleCheckedCitiesChange" style="display: flex; flex-wrap: wrap;padding-left: 45px;margin-bottom: 50px;">
                <el-checkbox v-for="(itme,index) in citiesList" :label="itme.name + itme.value" :key="index" style="width: 40%; margin-top: 20px;"> {{ itme.name }} {{ itme.value }} </el-checkbox>
            </el-checkbox-group>


            <el-table v-if="CourseCancellationomponentsTypeDistinguish === '课消审批'" ref="multipleTable"  @selection-change="handleSelectionChange" :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="200">
                <el-table-column type="selection" width="55">  </el-table-column>
                <el-table-column prop="courseDate" label="日期" show-overflow-tooltip></el-table-column>
                <el-table-column prop="courseStartTime" label="开始时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="courseEndTime" label="结束时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="courseName" label="课程" show-overflow-tooltip></el-table-column>
                <el-table-column prop="studentName" label="学员" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="isSales" label="课消状态" show-overflow-tooltip>
                  <template slot-scope="scope">
                      <div v-if="scope.row.isSales === 0">未课消</div>
                      <div v-if="scope.row.isSales === 1">已课消</div>
                  </template>
                </el-table-column> -->
                <el-table-column prop="salesNum" label="课消次数" show-overflow-tooltip></el-table-column>
                <el-table-column prop="salesMoney" label="课消金额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="classFee" label="老师课时费" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="productClassType" label="班型" show-overflow-tooltip>
                  <template slot-scope="scope">
                      <div v-if="scope.row.productClassType === 1">1v1</div>
                      <div v-if="scope.row.productClassType === 2">1v2</div>
                      <div v-if="scope.row.productClassType === 3">1v3</div>
                  </template>
                </el-table-column>
                <el-table-column prop="classPersonType" label="上课人员" show-overflow-tooltip>
                  <template slot-scope="scope">
                      <div v-if="scope.row.classPersonType === 1">孩子</div>
                      <div v-if="scope.row.classPersonType === 2">孩子和父亲</div>
                      <div v-if="scope.row.classPersonType === 3">孩子和母亲</div>
                      <div v-if="scope.row.classPersonType === 4">父亲</div>
                      <div v-if="scope.row.classPersonType === 5">母亲</div>
                      <div v-if="scope.row.classPersonType === 6">父亲和母亲</div>
                      <div v-if="scope.row.classPersonType === 7">孩子、父亲、母亲</div>
                  </template>
                </el-table-column>
                <el-table-column prop="feeProduct" label="扣费产品" show-overflow-tooltip></el-table-column>
                <el-table-column prop="giveHour" label="赠送课消次数" show-overflow-tooltip width="150"></el-table-column>
            </el-table>

            <el-table v-if="CourseCancellationomponentsTypeDistinguish === '取消课消审批'" ref="multipleTable"  @selection-change="handleSelectionChange" :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="200">
                <el-table-column type="selection" width="55">  </el-table-column>
                <el-table-column prop="studentName" label="姓名" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sex" label="性别" show-overflow-tooltip>
                  <template slot-scope="scope">
                      <div v-if="scope.row.sex === 1">男</div>
                      <div v-if="scope.row.sex === 2">女</div>
                  </template>
                </el-table-column>
                <el-table-column prop="gradeName" label="年级" show-overflow-tooltip></el-table-column>
                <el-table-column prop="educationType" label="上课方式" show-overflow-tooltip>
                  <template slot-scope="scope">
                      <div v-if="scope.row.educationType === 1">网课</div>
                      <div v-if="scope.row.educationType === 2">上门</div>
                      <div v-if="scope.row.educationType === 3">门店</div>
                  </template>
                </el-table-column>
                <el-table-column prop="telephone" label="联系电话" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="classEnding" label="结课状态" show-overflow-tooltip>
                  <template slot-scope="scope">
                      <div v-if="scope.row.classEnding === 1">结课</div>
                      <div v-if="scope.row.classEnding === 2">未结课</div>
                  </template>
                </el-table-column> -->
                <el-table-column prop="address" label="家庭住址" show-overflow-tooltip></el-table-column>
            </el-table>



            <div style="display: flex;margin-top: 20px;margin-top: 50px;">
                <div>备注：</div>
                <div style=" width: 90%;">
                    <el-input  type="textarea"  placeholder="请输入内容"  v-model="textarea"  maxlength="30"  show-word-limit :autosize="{ minRows: 6, maxRows: 6 }" > </el-input>
                </div>
            </div>


            <span slot="footer" class="dialog-footer">
                <div style="text-align: end;">
                    <el-button size="small" type="primary" @click="closeEditDialogSubt">确认</el-button>
                    <el-button size="small"  @click="rejectDialogShowClr">关闭</el-button>
                </div>
            </span>
        </el-dialog>
    </div>
</template>


<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
export default {
    props:{
        CourseCancellationomponentsTypeDistinguish:{
            default:'',
            type:String
        },
        dataRow:{
            default:{},
            type:Object
        },
        dataListNode:{
            default:[],
            type: Array
        },
    },
    data(){
        return{
            rejectDialogShow:true,
            checkedCitiesList:[],

            citiesList:[],


            textarea:'',

            multipleSelectionList:[],
            dataList:[],

            checkedCitiesListString:'',
            newMultipleSelectionListString:'',

        }
    },

    mounted(){


        if(this.CourseCancellationomponentsTypeDistinguish === '课消审批'){


            this.citiesList = [
                { name: '统计类型: ' ,  value: '' +  this.dataRow.statisticsType === 1 ? '老师课消' : '' },
                { name: '老师姓名: ' ,  value: '' +  this.dataRow.teacherName ? this.dataRow.teacherName : ''  },
                { name: '实际课消次数: ' ,  value: '' +  this.dataRow.salesNum ? this.dataRow.salesNum : '' },
                { name: '实际课消金额: '  ,  value: '' +  this.dataRow.salesMoney ? this.dataRow.salesMoney : '' },
                { name: '老师课时费: ' ,  value: '' +  this.dataRow.classFee ? this.dataRow.classFee : ''  },
            ]
        }

        if(this.CourseCancellationomponentsTypeDistinguish === '取消课消审批'){

            this.citiesList = [
                { name: '课程: ', value: '' +  this.dataRow.courseName ? this.dataRow.courseName : '' },
                { name: '任课老师: ', value: '' +  this.dataRow.teacherName ? this.dataRow.teacherName : '' },
                { name: '日期: ', value: '' +  this.dataRow.courseDate ? this.dataRow.courseDate : ''},
                // { name: '排课状态: ', value: '' + this.dataRow.courseStatus === 1 ? '实际课' : this.dataRow.courseStatus === 2 ? '预排课' : '' },
                { name: '开始时间: ', value: '' + this.dataRow.courseStartTime ? this.dataRow.courseStartTime : '' },
                // { name: '同步状态: ', value: '' + this.dataRow.synchronizationStatus === 0 ? '未同步' : this.dataRow.synchronizationStatus === 1 ? '已同步' : '' },
                { name: '结束时间: ', value: '' + this.dataRow.courseEndTime ? this.dataRow.courseEndTime : '' },
                { name: '班型: ', value: '' + this.dataRow.productClassType === 1 ? '1v1' : this.dataRow.productClassType === 2 ? '1v2' : this.dataRow.productClassType === 3 ? '1v3' : ''},
                { name: '上课人员类型: ', value: '' + this.dataRow.classPersonType === 1 ? '孩子' : this.dataRow.classPersonType === 2 ? '孩子和父亲' : this.dataRow.classPersonType === 3 ? '孩子和母亲' : this.dataRow.classPersonType === 4 ? '父亲' : this.dataRow.classPersonType === 5 ? '母亲' : this.dataRow.classPersonType === 6 ? '父亲和母亲' : this.dataRow.classPersonType === 7 ? '孩子、父亲、母亲' : '' },
            ]
        }


        this.dataList = this.dataListNode

    },

    methods:{

        handleSelectionChange(val) {
            this.multipleSelectionList = val
            let newMultipleSelectionList = []

            this.multipleSelectionList.map((itme)=>{
                if(itme.courseDate){
                    newMultipleSelectionList.push('表格数据错误: 时间为' + itme.courseDate + '的表格行')
                }else{
                    newMultipleSelectionList.push('表格数据错误: 表格行')
                }
            })

            if(val.length > 0){
                this.newMultipleSelectionListString = newMultipleSelectionList.join(',')
            }else{
                this.newMultipleSelectionListString = ''
            }
        },

        closeEditDialogSubt(){

          console.log(this.newMultipleSelectionListString,'this.newMultipleSelectionListString')
          console.log(this.checkedCitiesListString,'this.checkedCitiesListString')

          if(this.CourseCancellationomponentsTypeDistinguish === '课消审批'){
            axios.post(`${apiBaseUrl}/salesAudit/audit`, { auditStatus: 1, id: this.dataRow.id, rejectCause: this.newMultipleSelectionListString ? this.checkedCitiesListString + ',' + this.newMultipleSelectionListString : this.checkedCitiesListString, remark: this.textarea },{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
              if(res.data.code === 200){
                this.$message({  message: res.data.message,   type: 'success' })
                this.$emit('handleEventBusSbut',false)
              }else{
                this.$message({  message: res.data.message,   type: 'error' })
              }
            })
          }
          if(this.CourseCancellationomponentsTypeDistinguish === '取消课消审批'){
            axios.post(`${apiBaseUrl}/cancelEnding/audit`, { auditStatus: 1, id: this.dataRow.id, rejectCause: this.newMultipleSelectionListString ? this.checkedCitiesListString + ',' + this.newMultipleSelectionListString : this.checkedCitiesListString, remark: this.textarea },{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
              if(res.data.code === 200){
                this.$message({  message: res.data.message,   type: 'success' })
                this.$emit('handleEventBusSbut',false)
              }else{
                this.$message({  message: res.data.message,   type: 'error' })
              }
            })
          }
        },

        rejectDialogShowClr(){
            this.$emit('handleEventBus', false)
        },

        handleCheckedCitiesChange(value){
            this.checkedCitiesListString = value.join(',')
            console.log(this.checkedCitiesListString)
        },

    }

}
</script>



<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/ApprovalManagement/CourseCancellRejectDialog.vue